<template>
  <div class="modal template-editor animated fadeIn" :class="{ 'is-active': $route.path.indexOf('/template/') > -1 }">
    <div class="modal-background"></div>

    <document-editor-main :payload="template" :document-loaded="templateLoaded" @update="updateDocument" :show-template-sidebar="showTemplateSidebar">
      <form slot="document-title" class="document-title-wrapper">
        <div class="label">
          <span class="page-header" @click="$router.push('/a/templates')">
            <i class="icon icon-arrow-left"></i>
            {{ $t('navigation.templates') }} /
          </span>
          <input type="text" name="template-title" :placeholder="$t('general.add_title_here')" v-model="template.title">
          <span class="click-to-edit">{{ $t('general.click_to_edit') }}</span>
        </div>
      </form>
    </document-editor-main>

    <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
      <div class="is-hidden-mobile show-sidebar" v-if="!showTemplateSidebar">
        <a class="button" @click="showTemplateSidebar = true">
          <span><i class="icon icon-edit"></i></span>
        </a>
      </div>
    </transition>

    <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
      <template-editor-sidebar :payload="template" @save="saveTemplate()" @update="updateDocument" @closeTemplateSidebar="showTemplateSidebar = false" v-if="showTemplateSidebar"></template-editor-sidebar>
    </transition>
  </div>
</template>

<script>
  import API from 'mixins/api';
  import DocumentEditorMain from '../partials/document-editor-main.vue';
  import TemplateEditorSidebar from '../partials/template-editor-sidebar.vue';

  export default {
    mixins: [API],
    components: {
      DocumentEditorMain,
      TemplateEditorSidebar,
    },
    data() {
      return {
        comments: [],
        template: {
          id: null,
          cover: {},
          body: []
        },
        showTemplateSidebar: true,
        templateLoaded: false,
        saveTimer: 0,
      }
    },
    beforeMount() {
      if (this.$route.params.id === 'new') {
        this.api().createTemplate().then(template => {
          this.template = template;
          this.$router.push('/a/template/' + this.template.id);
          this.templateLoaded = true;
          this.setDocumentDefaults();
        });
      } else {
        this.api().fetchTemplate(this.$route.params.id).then(template => {
          this.template = template;
          this.templateLoaded = true;
          this.setDocumentDefaults();
        });
      }

      this.showTemplateSidebar = (window.innerWidth > 1300);
      window.addEventListener('resize', this.onResize);
    },
    destroyed() {
      clearTimeout(this.saveTimer);
      window.removeEventListener('resize', this.onResize);
    },
    methods: {
      onResize() {
        this.showTemplateSidebar = (window.innerWidth > 1300);
      },
      goBack() {
        window.history.back();
      },
      setDocumentDefaults() {
        this.$set(this.template, 'options', _.extend({
          paperSize: 'letter',
          documentFont: 'Helvetica'
        }, this.template.options));
        this.$set(this.template, 'cover', _.extend({
          title: this.template.title,
          layout: 1,
          alignment: "center",
          backgroundColor: '#ffffff',
          color: '#000000'
        }, this.template.cover));
      },
      updateDocument(doc) {
        this.template.body = doc;
      },
      updateContent(options) {
        var part = _.findWhere(this.template.body, { id: options.part.id });

        if (part) {
          part.content = options.value;
        }
      },
      queueSave() {
        clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(this.saveTemplate, 5000);
      },
      saveTemplate() {
        clearTimeout(this.saveTimer);
        if (this.templateLoaded) {
          return this.api().updateTemplate(this.$route.params.id, this.template)
            .then(response => {
              (new Notyf()).confirm(this.$t('template_editor.saved'));
            }, response => {
              (new Notyf()).alert(this.$t('template_editor.saved_error'));
            });
        }
      }
    },
    watch: {
      'template': {
        handler: function() {
          this.queueSave();

          if (this.template.body && this.template.body.length <= 0) {
            this.$set(this.template, 'body', [{
              id: Math.floor(Math.random() * 100000000),
              type: 'text',
              icon: 'icon-p',
              title: 'Paragraph',
              content: '<p></p>'
            }]);
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }

  .modal-background {
    background: darken($eggshell, 2%);
    position: fixed;
  }

  .comments {
    position:fixed;
    left: 20px;
    bottom: 20px;
    display: flex;
    flex-direction: column;
    width: 60px;
    img {
      width: 60px;
      height: 60px;
      border-radius: 100px;
      margin-top: -15px;
      border: 1px solid $white;
      box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
    }
    .initials {
      width: 60px;
      height: 60px;
      border-radius: 100px;
      text-align: center;
      padding-top: 18px;
      font-size: 16px;
      margin-top: -15px;
      color: $white;
      background: $mutedblue;
    }
    .show-comments {
      margin-top: 10px;
      background: $white;
      box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
      border-radius: 100px;
      border-color: $white;
      width: 60px;
      height: 60px;
      color: $mutedblue;
      &:hover {
        border-color: $green;
        color: $green;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// template-editor-modal.vue?87f71cde